import React from "react";

const modal = props => {
  return (
    <div className="container">
      <div className={`alert alert-${props.type}`} role="alert">
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
          onClick={props.onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 className="alert-heading">{props.title}</h4>
        <hr />
        {props.children}
      </div>
    </div>
  );
};

modal.defaultProps = {
  type: "success"
};

export default modal;



// WEBPACK FOOTER //
// ./src/components/alert.js